import {CUSTOM_ELEMENTS_SCHEMA, NgModule, isDevMode, APP_INITIALIZER} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {SharedModule} from './shared/shared.module';
import {HTTP_INTERCEPTORS, HttpClient} from "@angular/common/http";
import {JwtInterceptor} from "./shared/core/auth/JwtInterceptor";
import {CacheInterceptor} from "./shared/core/interceptors/cache.interceptor";
import {ToastrModule} from "ngx-toastr";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {LoaderComponent} from "./shared/loader/loader.component";
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from "../environments/environment";
import {AngularFireModule} from "@angular/fire/compat";
import {AngularFireMessagingModule} from "@angular/fire/compat/messaging";
import {ConfigService} from "./shared/core/services/all-modules-services/config.service";
import PageRibbonComponent from "./feature-module/common/ribbon/page-ribbon.component";


// Required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const firebaseConfig = {
    apiKey: "AIzaSyCS6GdWqmybGBeooajlWGJ_gzLjMhU2WEc",
    authDomain: "wacni-9408c.firebaseapp.com",
    projectId: "wacni-9408c",
    storageBucket: "wacni-9408c.firebasestorage.app",
    messagingSenderId: "940359506307",
    appId: "1:940359506307:web:eb1eea26cace53c70e3eb6",
    measurementId: "G-6MHQDF3DJE",
    vapidKey: "BBpm8Q1ZRSVjHqDobpV9ChAo8YuPlqk2P4e_D9l9uSlNbzGAydsWtZLmQ6Px4JuxkP7OQQgv74bxNqX41zovwyQ"
};

@NgModule({
    declarations: [AppComponent],
    imports: [BrowserModule,
        AppRoutingModule,
        SharedModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            positionClass: 'toast-top-right',
            timeOut: 4000,
            progressBar: true,
            progressAnimation: 'decreasing',
            preventDuplicates: true,
            closeButton: true,
            easeTime: 250,
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        LoaderComponent,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: !isDevMode(),
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        }),
        AngularFireModule.initializeApp(firebaseConfig),
        AngularFireMessagingModule, PageRibbonComponent,
    ],
    providers: [
        provideAnimationsAsync(),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JwtInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CacheInterceptor,
            multi: true
        }
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent],
})
export class AppModule {
}
